import http from "@/library/http";

const signup = async (campaignId: string, tag: string, payload: { userid: string; first_name: string; last_name: string }): Promise<any> => {
  return http.post(`/signup/${campaignId}/${tag}`, payload);
};

export default {
  signup,
};
